import React, { useState, Fragment } from "react";
import { Switch } from "@headlessui/react";

export type CaSwitchProps = {
  value: boolean;
  onChange: (checked: boolean) => void;
};

function CaSwitch({ value, onChange }: CaSwitchProps) {
  const [enabled, setEnabled] = useState(value);

  const handleChange = (checked: boolean) => {
    setEnabled(checked);
    onChange(checked);
  };

  return (
    <Switch checked={enabled} onChange={handleChange} as={Fragment}>
      {({ checked }) => (
        <button
          className={`${
            checked ? "bg-purple" : "bg-gray-200"
          } relative inline-flex h-6 w-11 items-center rounded-full`}
        >
          <span className='sr-only'>Enable notifications</span>
          <span
            className={`${
              checked ? "translate-x-6" : "translate-x-1"
            } inline-block h-4 w-4 transform rounded-full bg-white transition`}
          />
        </button>
      )}
    </Switch>
  );
}

export default CaSwitch;
